// extracted by mini-css-extract-plugin
export default {"flTable":"Table_flTable__l5DKj"};